/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { useContext, useEffect, useRef, useState } from "react";
import { getData } from "../../Services/getData";
import { Vocabulary } from "../../Utils/Vocabulary";
import genericStyles from "../../Styles/genericStyles.module.css";
import { CustomThemeContext } from "../../Context/CustomThemeProvider";
import styles from "../../Styles/previewPDF.module.css";
import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import { ZoomIn, ZoomOut } from "@mui/icons-material";
import { PreviewDocumentProps } from "../../Utils/Types";
import { pdfjs, Document as PdfDocument, Page } from "react-pdf";

pdfjs.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

function PreviewPDFDoc(props: PreviewDocumentProps) {
  const { urls, htmlContent, open, onClose, title } = props;
  const contentRef: any = useRef(null);
  const scaleAmount = 0.5;
  const themeContext: any = useContext(CustomThemeContext);
  const [state, setState] = useState({
    numPages: 0,
    templateLoaded: 0,
    pageNumber: 1,
    scale: 1.0,
    showEmail: false,
    emailSent: false,
    addImage: false,
  });
  const [content, setContent] = useState(htmlContent);

  /**
   *
   */
  useEffect(() => {
    if (urls?.length) {
      const url = urls[0];
      getData(url).then((response: any) => {
        if (response?.errors) return;
        setState({
          ...state,
          templateLoaded: 1,
        });
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [urls]);

  /**
   *
   */
  useEffect(() => {
    if (!content) {
      setContent(htmlContent);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [htmlContent]);

  /**
   *
   * @param data
   */
  const onDocumentLoadSuccess = (data: { numPages: any; }) => {
    const { numPages } = data;
    setState({ ...state, numPages });
  };

  /**
   *
   */
  const zoomIn = () => {
    setState({ ...state, scale: state.scale + scaleAmount });
  };

  /**
   *
   */
  const zoomOut = () => {
    setState({ ...state, scale: state.scale - scaleAmount });
  };

  /**
   *
   */
  const renderPages = () => {
    const pages: Array<any> = [];
    for (let i = 0; i < state.numPages; i++) {
      pages.push(
        <Page
          renderTextLayer={false}
          renderAnnotationLayer={false}
          className={styles.pdfPreviewPage}
          key={`page_${i + 1}`}
          scale={state.scale}
          pageNumber={i + 1}
        />
      );
    }
    return pages;
  };

  return (
    <div
      style={{ width: "100%", height: "100%" }}
    >
      <DialogContent ref={contentRef} className={styles.dialogContent}>
        {urls?.length ? (
          <>
            {!state.templateLoaded ? (
              <div className={styles.loadingWrapper}>
                <CircularProgress color="secondary" />
              </div>
            ) : (
              urls.map((pdfUrl, idx) => (
                <PdfDocument
                  key={idx}
                  file={pdfUrl}
                  onLoadSuccess={({ numPages }) =>
                    setState((prev) => ({
                      ...prev,
                      [`numPages_${idx}`]: numPages,
                    }))
                  }
                >
                  {Array.from(
                    new Array((state as any)[`numPages_${idx}`] || 0),
                    (_, pageIndex) => (
                      <Page
                        key={`p-${idx}-${pageIndex + 1}`}
                        pageNumber={pageIndex + 1}
                        renderTextLayer={false}
                        renderAnnotationLayer={false}
                        scale={state.scale}
                        className={styles.pdfPreviewPage}
                      />
                    )
                  )}
                </PdfDocument>
              ))

            )}
          </>
        ) : (
          Vocabulary.loading
        )}
      </DialogContent>
      <DialogActions classes={{ root: styles.actionsWrapper }}>
        <IconButton disabled={state.scale <= 0.3} onClick={zoomOut}>
          <ZoomOut />
        </IconButton>
        <IconButton disabled={state.scale >= 2} onClick={zoomIn}>
          <ZoomIn />
        </IconButton>
        <Button
          onClick={() => props.onClose(state.emailSent)}
          style={{ background: themeContext.theme?.palette.cancel?.main }}
        >
          {Vocabulary.close}
        </Button>
      </DialogActions>
    </div>
  );
}

export default PreviewPDFDoc;